import { useLocation } from '@lingoda/router';
import { getStorageValue } from '@lingoda/utils';
import { STORAGE_KEY_INITIAL_IS_IN_TRIAL } from '../../constants';
import { useIsOnboardingM2PledgeEnabled } from '../../hooks/useIsOnboardingM2PledgeEnabled';
import {
    getActiveSurveySteps,
    getOnboardingStepByPathname,
    getOnboardingTotalSteps,
} from '../../onboardingSteps';
import { ProgressBar } from './ProgressBar';

export const SurveyProgressBar = () => {
    const { pathname } = useLocation();
    const { isPledgeEnabled } = useIsOnboardingM2PledgeEnabled();
    const isInTrial = !!getStorageValue(STORAGE_KEY_INITIAL_IS_IN_TRIAL);
    const surveyStepCount = getActiveSurveySteps(isPledgeEnabled).length;
    const activeStep = getOnboardingStepByPathname(pathname, isInTrial, surveyStepCount);

    if (activeStep === null) {
        return null;
    }

    return (
        <ProgressBar
            activeStep={activeStep}
            totalSteps={getOnboardingTotalSteps(isInTrial, surveyStepCount)}
        />
    );
};
